import React, { Component } from 'react';

import ParkinglocationSelect from './ParkinglocationSelect';
import ParkinglocationModel from './ParkinglocationModel';

import MapWithDrawingManager from './MapWithDrawingManager';
import GoogleMap from './GoogleMap';

import { Form, Input, InputNumber, Button, Modal, Icon, Tooltip, Switch } from 'antd';
const FormItem = Form.Item;

const generateGUID = () => {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

class AutoParkinglocationForm extends Component {

  state = {
    modalVisible: false,
    defaultValues: null,
    RoadSign: null
  }

  form = null;

  componentWillReceiveProps(nextProps) {
    let newState = {};
    newState.modalVisible = nextProps.modalVisible;
    this.setState(newState);
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.props.onSuccess(this.props.form, values);
      }
    });
  }

  handleValidateZoneDetections(rule, value, cb) {
    if (this.props.form.getFieldValue('IsZoneDetections') == true && JSON.parse(value).length !== 5) {
      cb('Definice této zóny musí obsahovat 5 bodů!');
    }
    cb();
  }

  renderForm() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };

    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    const fullFormItemLayout = {
      labelCol: {
        xs: { span: 0 },
        sm: { span: 0 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 },
      },
    };

    return (
      <Form onSubmit={this.handleSubmit} ref={ref => { this.form = ref }}>
        <FormItem
          {...formItemLayout}
          label="Lokalita" >
          {getFieldDecorator('ParkingLocationID', {
            rules: [{
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <ParkinglocationSelect onChange={(value) => {
              this.props.form.setFieldsValue({ ParkingLocationID: value });
              var defaultValues = {};
              ParkinglocationModel.get(value)
                .then(pl => {
                  defaultValues.Definition = pl.Definition;
                  this.props.form.setFieldsValue({ Definition: defaultValues.Definition });
                  this.setState({
                    defaultValues: defaultValues
                  });
                });
            }} />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Identifikátor zóny" >
          {getFieldDecorator('ZoneID', {
            rules: [{
              type: 'string', message: 'Položka musí obsahovat text!',
            }, {
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <Input
              addonAfter={
                <Tooltip placement="bottomRight" title={'Vygenerovat GUID'}>
                  <Icon type="retweet"
                    onClick={() => {
                      this.props.form.setFieldsValue({
                        ZoneID: generateGUID()
                      });
                    }} />
                </Tooltip>
              } />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Popis" >
          {getFieldDecorator('Description', {
            rules: [{
              type: 'string', message: 'Položka musí obsahovat text!',
            }],
          })(
            <Input.TextArea rows={2} />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Zona přehledové kamery" >
          {getFieldDecorator('IsZoneDetections', {
          })(
            <Switch />
          )}
        </FormItem>
        {this.props.form.getFieldValue('IsZoneDetections') === true
          ? <FormItem
            {...formItemLayout}
            label="Vzdálenost detekce od značky" >
            {getFieldDecorator('Distance', {
              rules: [{
                type: 'integer', message: 'Položka musí obsahovat číslo!',
              }, {
                required: this.props.form.getFieldValue('IsZoneDetections'), message: 'Zadejte vzdálenost detekce od značky!',
              }],
            })(
              <InputNumber
                min={5}
                max={100} />
            )}
          </FormItem>
          : null}
        {/* <FormItem
          {...formItemLayout}
          label="Definice zony" >
          {getFieldDecorator('Coordinations', {
            rules: [{
              type: 'string', message: 'Položka musí obsahovat text!',
            }, {
              required: true, message: 'Zadejte položku nakreslením polygonu do mapy!',
            }, {
              validator: this.handleValidateZoneDetections.bind(this)
            }],
          })(
            <Input
              disabled={true} />
          )}
        </FormItem> */}
        {this.props.form.getFieldValue('IsZoneDetections') === true
          ? <FormItem
            {...formItemLayout}
            label="Umistení značky" >
            {getFieldDecorator('RoadSignDefinition', {
              rules: [{
                type: 'object', message: 'Položka musí obsahovat objekt!',
              }, {
                required: this.props.form.getFieldValue('IsZoneDetections'), message: 'Zadejte položku umístěním bodu do mapy!',
              }],
            })(
              <Input
                disabled={true} />
            )}
          </FormItem>
          : null}
        <FormItem
          {...fullFormItemLayout}
          label="Definice zóny" >
          {getFieldDecorator('Definition', {
            rules: [{
              type: 'object', message: 'Položka musí obsahovat text!',
            }, {
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            this.state.defaultValues
              ? <GoogleMap
                drawingManagerEnabled={true}
                defaultPolygon={
                  this.state.defaultValues && this.state.defaultValues.Definition
                    ? this.state.defaultValues.Definition.coordinates[0]
                    : null
                }
                onPolygonChanged={(coordinates) => {
                  let definition = {
                    coordinates: [],
                    type: 'Polygon'
                  }
                  definition.coordinates.push(coordinates);
                  this.props.form.setFieldsValue({
                    Definition: definition
                  });
                }}
                onMarkerChanged={(coordinates) => {
                  let definition = {
                    coordinates: [],
                    type: 'Point'
                  }
                  definition.coordinates = coordinates;
                  this.props.form.setFieldsValue({
                    RoadSignDefinition: definition
                  });
                }} />
              : <div></div>

          )}
        </FormItem>
        <FormItem {...tailFormItemLayout}>
          <Button type="primary" htmlType="submit">Uložit</Button>
        </FormItem>
      </Form>
    );
  }

  render() {
    if (this.props.type && this.props.type === 'modal') {
      return (
        <Modal
          width={750}
          title="Vytvoření nové lokality"
          visible={this.state.modalVisible}
          onCancel={() => {
            this.props.onModalCancel();
            this.setState({ modalVisible: false, defaultValues: null, RoadSign: null });
          }}
          footer={<p></p>}
          maskClosable={false}>
          {this.state.modalVisible
            ? this.renderForm()
            : null}
        </Modal>
      )
    } else {
      return this.renderForm();
    }
  }
}

const WrappedParkinglocationForm = Form.create()(AutoParkinglocationForm);

export default WrappedParkinglocationForm;


// WEBPACK FOOTER //
// ./src/components/AutoParkinglocationForm.js